import { ROUTE_PATH, TEMPLATE_OPTIONS, genderList } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class MentorMetaModel extends FormMetaModel {
    constructor() {
        super('Add Mentor', ROUTE_PATH.mentorList, '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const mentorName = new SmMetaInputModel(
            'mentorName',
            'mentorName',
            'input',
            true,
            'col-6 col-md-6 col-lg-6',
            1,
            1,
            'Mentor Name',
            'text',
            '^[a-zA-Z ]+$',
            false,
            true,
            true,
            false,
            30,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Name"
     
        );
        const mentorEmail = new SmMetaInputModel(
            'mentorEmail',
            'mentorEmail',
            'input',
            true,
            'col-6 col-md-6 col-lg-6',
            1,
            2,
            'Mentor Email',
            'text',
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$',
            false,
            true,
            true,
            false,
            35,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Email"
        );
        //mentorContact
        const mentorContact = new SmMetaInputModel(
            'mentorContact',
            'mentorContact',
            'input',
            true,
            'col-6 col-md-6 col-lg-6',
            2,
            3,
            'Mentor Contact',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Contact"
            
        );
        const mentorStateId = new SmMetaSelectModel(
            'mentorStateId',
            'mentorStateId',
            'select',
            true,
            'col-12 col-md-6 col-lg-6',
            2,
            4,
            'State',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'stateName',
            'id',

        );
        const mentorGender = new SmMetaSelectModel(
            'mentorGender',
            'mentorGender',
            'select',
            true,
            'col-12 col-md-6 col-lg-6',
            3,
            5,
            'Gender',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            genderList,
            'name',
            'value',

        );
        // new SmMetaInputModel(
        //     'mentorContact',
        //     'mentorContact',
        //     'input',
        //     true,
        //     'col-6 col-md-6 col-lg-6',
        //     2,
        //     3,
        //     'Mentor Contact',
        //     'text',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     12,
        //     10
        // );
        const mentorCompany = new SmMetaInputModel(
            'mentorCompany',
            'mentorCompany',
            'input',
            true,
            'col-6 col-md-6 col-lg-6',
            3,
            6,
            'Company',
            'text',
            '',
            false,
            true,
            true,
            false,
            50,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Company"

        );
        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };
        return {
            formInfo,
            buttons,
            mentorName,
            mentorEmail,
            mentorContact,
            mentorStateId,
            mentorGender,
            mentorCompany
        }
    }


}